/**
 * Skeleton Loader Components
 */

interface SkeletonProps {
  width?: string | number
  height?: string | number
  className?: string
  style?: React.CSSProperties
}

export function Skeleton({ width, height, className, style }: SkeletonProps) {
  return (
    <div
      className={className}
      style={{
        width: width || '100%',
        height: height || '1rem',
        background: 'var(--color-gray-200)',
        borderRadius: 'var(--radius-md)',
        animation: 'pulse 1.5s var(--ease-in-out) infinite',
        ...style,
      }}
    />
  )
}

export function CardSkeleton() {
  return (
    <div className="card">
      <Skeleton height="1.5rem" width="60%" style={{ marginBottom: '1rem' }} />
      <Skeleton height="2rem" width="40%" style={{ marginBottom: '0.5rem' }} />
      <Skeleton height="1rem" width="80%" />
    </div>
  )
}

export function PlanCardSkeleton() {
  return (
    <div
      style={{
        border: '1px solid var(--color-gray-300)',
        borderRadius: 'var(--radius-lg)',
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--color-white)',
      }}
    >
      <Skeleton height="1.5rem" width="70%" style={{ marginBottom: '0.5rem' }} />
      <Skeleton height="2.5rem" width="50%" style={{ marginBottom: '1rem' }} />
      <Skeleton height="1rem" width="90%" style={{ marginBottom: '0.5rem' }} />
      <Skeleton height="1rem" width="85%" style={{ marginBottom: '0.5rem' }} />
      <Skeleton height="1rem" width="75%" style={{ marginBottom: '1rem' }} />
      <Skeleton height="2.5rem" width="100%" style={{ marginTop: 'auto' }} />
    </div>
  )
}

export function TableRowSkeleton() {
  return (
    <div style={{ display: 'flex', gap: '1rem', padding: '1rem', borderBottom: '1px solid var(--color-gray-200)' }}>
      <Skeleton height="1rem" width="30%" />
      <Skeleton height="1rem" width="25%" />
      <Skeleton height="1rem" width="20%" />
      <Skeleton height="1rem" width="15%" />
    </div>
  )
}

export function InventoryFeedCardSkeleton() {
  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
        <div style={{ flex: 1 }}>
          <Skeleton height="1.25rem" width="60%" style={{ marginBottom: '0.5rem' }} />
          <Skeleton height="0.85rem" width="40%" />
        </div>
        <Skeleton height="1.5rem" width="60px" style={{ borderRadius: '12px' }} />
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <Skeleton height="0.9rem" width="50%" style={{ marginBottom: '0.5rem' }} />
        <Skeleton height="0.85rem" width="45%" />
      </div>

      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        <Skeleton height="2.25rem" width="calc(50% - 0.25rem)" style={{ borderRadius: '4px' }} />
        <Skeleton height="2.25rem" width="calc(50% - 0.25rem)" style={{ borderRadius: '4px' }} />
        <Skeleton height="2.25rem" width="40px" style={{ borderRadius: '4px' }} />
      </div>
    </div>
  )
}

